import React, { useState, useEffect,useRef } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus, AiOutlineClose } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { AiOutlineClose as CloseIcon } from 'react-icons/ai';
import { GetAllKeyData, GetEmployee, GetDepartment, GetStatusListByType, AddKeyMaster, UpdateKeyMaster, GetKeyStatus } from '../../services/Api';

import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// Your existing code...


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#2B3497;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;
// const Input = styled.input`
//   width: 100%;
//   padding: 8px 0;
//   border: none;
//   border-bottom: 1px solid #2B3497;
//   font-family: 'Segoe UI', 'Regular';
//   margin-top:10px;
//   background: transparent;
//   &:focus {
//     outline: none;
//     border-bottom: 2px solid #2B3497;
//   }
// `;


const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const LocationInput = styled.input`
  border: none;
  border-bottom: 2px solid #3d46b4;
  outline: none;
  font-size: 16px;
  padding: 10px;
  margin-left: 20px;
  width: 200px;
  background: transparent;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;

`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
const Asterisk = styled.span`
  color: red;
`;

// const DropdownSelect = styled.select`
//   background-color: #fff;
//   color: #293495;
//   boder:none;
//   border-bottom: 1px solid #3d46b4;
//   padding: 8px;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 16px;
//   &:focus {
//     outline: none;
//     border-color: #293495;
//   }
// `;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 1px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;
export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 29px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  z-index: 1000;
  width: 80%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom:10px;
`;

export const ModalTitle = styled.h2`
  color: #293495;
  font-size: 20px;
  margin: 0;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FlexRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const InputFieldHalf = styled.div`
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #000;
  font-weight: 600;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  font-family: 'Segoe UI', 'Regular';
  background: transparent;
background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;
  cursor: pointer;
  &:focus {
    outline: none;
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  }
`;

const DropdownSelect = styled.select`
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#293495')};
  padding: 8px 0;
  font-size: 14px;
  outline: none;
  background: transparent;
  background-image: url('data:image/svg+xml;utf8,<svg fill="none" stroke="${props =>
        props.hasError ? 'red' : '%23293495'}" stroke-width="2" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;
  cursor: pointer;

  &:focus {
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#1a237e')};
  }
`;

export const ResetButton = styled.button`
   background-color: red;
margin-top: 20px;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: darkred;
  }
`;

export const SubmitButton = styled.button`
 margin-top: 20px;
  background-color: #293495;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: #1f2970;
  }
`;
const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;



const KeyMaster = () => {
    const [showInput, setShowInput] = useState(false);
    const [locationName, setLocationName] = useState('');
    const [locations, setLocations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [showPagination, setShowPagination] = useState(false);
    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('asc');

    // Sort function


    const rowsPerPage = 5;

    const [allKeysData, setAllKeysData] = useState([]);
    const [allEmployee, setAllEmployee] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [keyStatusList, setKeyStatusList] = useState([]);
    const [currentStatusId, setCurrentStatusId] = useState(0);


    console.log("key status list", keyStatusList);

    // Fetch key logs for the selected date
    const fetchAllKeys = async () => {
        try {
            const response = await GetAllKeyData(currentStatusId);
            console.log("All Key:", response);
            setAllKeysData(response || []);
        } catch (error) {
            console.error("Failed to fetch All keys:", error);
        }
    };

    // Fetch key logs for the selected date
    const fetchEmployee = async () => {
        try {
            const response = await GetEmployee();
            console.log("All Employee:", response);
            setAllEmployee(response || []);
        } catch (error) {
            console.error("Failed to fetch All Employees:", error);
        }
    };

    const fetchDepartment = async () => {
        try {
            const response = await GetDepartment();
            console.log("Department name Response", response)
            setDepartments(response);
        } catch (error) {
            console.error('Error fetching department name:', error);
        }
    }

    const fetchStatusList = async () => {
        try {
            const response = await GetStatusListByType();
            console.log("List type", response);
            setStatusList(response);

        } catch (error) {
            console.error('Error fetching department name:', error);
        }
    }
    const fetchKeyStatusList = async () => {
        try {
            const response = await GetKeyStatus();
            console.log("key status list", response);
            setKeyStatusList(response);

        } catch (error) {
            console.error('Error fetching department name:', error);
        }
    }

    useEffect(() => {


        fetchAllKeys();
        fetchEmployee();
        fetchDepartment();
        fetchStatusList();
        fetchKeyStatusList();
    }, [currentStatusId])

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await axios.get('/Location');
                if (response.data) {
                    // Assuming the API returns an array of locations
                    setLocations(response.data);
                    setShowPagination(true); // Show pagination after submitting at least one row

                } else {
                    setLocations([]); // Ensure locations is always an array
                }
            } catch (error) {
                console.error('Error fetching locations:', error);
                setLocations([]); // Ensure locations is always an array even if the request fails
            }
        };

        fetchLocations();
    }, []);
    const sortData = (data, column, direction) => {
        const sortedData = [...data].sort((a, b) => {
            if (direction === 'asc') {
                return a[column] > b[column] ? 1 : -1;
            } else {
                return a[column] < b[column] ? 1 : -1;
            }
        });
        return sortedData;
    };

    const handleSort = (column) => {
        const newDirection = sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
        setSortColumn(column);
        setSortDirection(newDirection);

        console.log("keys logs", allKeysData);

        const sortedData = [...allKeysData].sort((a, b) => {
            let valA = a[column];
            let valB = b[column];

            if (column.includes("DateTime")) {
                valA = new Date(valA);
                valB = new Date(valB);
            }

            if (valA < valB) return newDirection === "asc" ? -1 : 1;
            if (valA > valB) return newDirection === "asc" ? 1 : -1;
            return 0;
        });

        setAllKeysData(sortedData);
    };


    const handleAddLocationClick = () => {
        handleReset();
        setIsModalOpen(true)
    };
    const handleCloseModal = () => {
        setIsEditing(false);
        setIsModalOpen(false);
        setErrors({});
    }

    // const handleEdit = (location) => {

    // }

    const handleDelete = (id) => {
        confirmAlert({
            title: <span style={{ color: '#dc3545' }}>Warning</span>,
            message: 'Are you sure you want to delete this location?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: async () => {
                        try {
                            // Sending the PUT request to mark the location as deleted
                            await axios.put('/Location', {
                                id: id,
                                locationName: locations.find(location => location.id === id)?.locationName,
                                isDeleted: true
                            });

                            // Update the local state to remove the deleted location from the UI
                            setLocations((prevData) => prevData.filter(location => location.id !== id));

                            // Show success toast message
                            toast.success('Location Deleted Successfully');
                        } catch (error) {
                            console.error('Error deleting location:', error);
                            // Show error toast message
                            toast.error('Failed to Delete Location');
                        }
                    }
                },
                {
                    label: 'No',
                    onClick: () => {
                        // Close dialog without taking any action
                    }
                }
            ]
        });
    };


    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Filtered keys
    const filteredKeys = Array.isArray(allKeysData)
        ? allKeysData.filter(item => {
            const term = searchTerm?.toLowerCase().trim();
            if (!term) return true;

            const excludeKeys = ['createdBy', 'createdOn', 'modifiedBy', 'modifiedOn'];

            return Object.entries(item).some(([key, value]) =>
                !excludeKeys.includes(key) &&
                String(value ?? '').toLowerCase().includes(term)
            );
        })
        : [];

    // Pagination logic
    const itemsPerPage = 5;
    const totalItems = filteredKeys.length;
    const maxPage = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    const safeCurrentPage = Math.min(currentPage, maxPage);
    const indexOfLastItem = safeCurrentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredKeys.slice(indexOfFirstItem, indexOfLastItem);




    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const totalPages = Math.ceil(filteredKeys.length / rowsPerPage);

    const handlePageChange = (event) => {
        setCurrentPage(Number(event.target.value));
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const currentRows = filteredKeys.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

        let startPage = Math.max(currentPage - 5, 1);
        let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

        // Adjust startPage if endPage exceeds totalPages
        if (endPage === totalPages) {
            startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <PaginationButton
                    key={i}
                    className={currentPage === i ? 'active' : ''}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </PaginationButton>
            );
        }

        return pageNumbers;
    };
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpandCollapse = () => {
        setIsExpanded(!isExpanded);
    };

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupData, setPopupData] = useState('');

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);


    const [uploadDocs, setUploadDocs] = useState(false);
    const [uploadNDA, setUploadNDA] = useState(false);
    const [uploadTraining, setUploadTraining] = useState(false);
    const [uploadSafety, setUploadSafety] = useState(false);
    const [documentFile, setDocumentFile] = useState('');
    const [ndaFile, setNdaFile] = useState('');
    const handleReset = () => {
        setUploadDocs(false);
        setUploadNDA(false);
        setUploadTraining(false);
        setUploadSafety(false);
        setDocumentFile('');
        setNdaFile('');
        // reset any other form fields here

        // Reset form & refresh data
        setFormData({
            keyName: '',
            keyNumber: '',
            keyOwnerId: '',
            keyAddedDate: '',
            departmentID: '',
            roomAreaName: '',
            statusID: 1,
        });
    };

    const [formData, setFormData] = useState({
        keyName: '',
        keyNumber: '',
        keyOwnerId: '',
        keyAddedDate: '',
        departmentID: '',
        roomAreaName: '',
        statusID: 1, //  Default is 1
    });


    console.log("my Form data", formData);
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [errors, setErrors] = useState({});


    const handleSubmit = async () => {
        const newErrors = {};

        // Validate required fields
        if (!String(formData.keyName).trim()) newErrors.keyName = 'Key name is required.';
        if (!String(formData.keyNumber).trim()) newErrors.keyNumber = 'Key number is required.';
        if (!String(formData.keyOwnerId).trim()) newErrors.keyOwnerId = 'Key owner is required.';
        if (!String(formData.keyAddedDate).trim()) newErrors.keyAddedDate = 'Key added date is required.';
        if (!String(formData.departmentID).trim()) newErrors.departmentID = 'Department is required.';
        if (!String(formData.roomAreaName).trim()) newErrors.roomAreaName = 'Room/Area is required.';
        if (!String(formData.statusID).trim()) newErrors.statusID = 'Status is required.';

        // If any errors, show and block submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            toast.error('Please fill in all required fields.');
            return;
        }

        try {
            if (isEditing) {
                const response = await UpdateKeyMaster({ ...formData, id: editingId, });
                toast.success(response?.res_message || 'updated successfully!');
            } else {
                const response = await AddKeyMaster(formData);
                toast.success(response?.res_message || 'added successfully!');
            }

            // Reset form & refresh data
            setFormData({
                keyName: '',
                keyNumber: '',
                keyOwnerId: '',
                keyAddedDate: '',
                departmentID: '',
                roomAreaName: '',
                statusID: '',
            });
            setErrors({});
            setIsEditing(false);
            setEditingId(null);
            setIsModalOpen(false);
            fetchAllKeys(); // Refresh list
        } catch (err) {
            toast.error(isEditing ? 'Failed to update courier.' : 'Failed to add courier.');
            console.error(err);
        }
    };

    const handleEdit = (row) => {
        console.log("row", row)
        setFormData({
            keyName: row.keyName,
            keyNumber: row.keyNumber,
            keyOwnerId: row.keyOwnerID,
            keyAddedDate: row.keyAddedDate,
            departmentID: row.departmentID,
            roomAreaName: row.roomAreaName,
            statusID: row.statusID
        });
        setEditingId(row.id); // or row.courierId based on your backend
        setIsEditing(true);
        setIsModalOpen(true);
        setErrors({});

    };

    const formatDateForInput = (datetime) => {
        if (!datetime) return '';
        const date = new Date(datetime);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    };

    const [isPanelOpen, setIsPanelOpen] = useState(false);

    // Function to toggle the export options panel
    const togglePanel = () => {
        setIsPanelOpen((prevState) => !prevState);
    };

    const handleExportOptionClick = (format) => {
         if (filteredKeys.length === 0) {
              toast.warning('No data available to export.');
              return;
            }
        if (format === 'excel') {
            exportToExcel(); // Call the Excel export function
        } else if (format === 'pdf') {
            exportToPDF(); // Call the PDF export function
        }

        // Close the panel after making a selection
        setIsPanelOpen(false);
    };

    const exportToExcel = () => {
        const filteredDataNee = filteredKeys.map((row) => ({
            KeyName: row.keyName,
            KeyReference: row.keyNumber,
            KeyOwner: row.keyOwnerName,
            KeyAddedDate: row.keyAddedDate,
            KeyStatus: row.status,
            Department: row.department,
            RoomorArea: row.roomAreaName

        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Key Master Reports');

        // Adjust column widths for better alignment
        worksheet['!cols'] = [
            { wpx: 150 }, // Visitor Name
            { wpx: 150 }, // Visitor Mobile
            { wpx: 150 }, // Visitor Mobile
            { wpx: 200 }, // Visitor Company
            { wpx: 200 }, // Visitor Company
            { wpx: 200 }, // Visitor Company
            { wpx: 200 }, // Visitor Company

        ];

        XLSX.writeFile(workbook, 'Key_Master_Report.xlsx');
    };

    const exportToPDF = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
      
        const header = () => {
          doc.setFontSize(10);
          doc.setFont("helvetica", "normal");
      
          // Left Header Text
          doc.text("SecoreX - Visitor Management System", 14, 10);
      
          // Horizontal Line
          doc.setDrawColor(0);
          doc.setLineWidth(0.5);
          doc.line(14, 12, pageWidth - 14, 12);
      
          // Centered Title
          doc.setFontSize(14);
          doc.setFont("helvetica", "bold");
          doc.text("Key Master Reports", pageWidth / 2, 22, { align: "center" });
      
          doc.setFontSize(10); // Reset for table
        };
      
        const footer = (data) => {
          const pageCount = doc.internal.getNumberOfPages();
          const currentPage = data.pageNumber;
      
          doc.setDrawColor(0);
          doc.line(14, pageHeight - 15, pageWidth - 14, pageHeight - 15);
      
          doc.text("Key Master Reports", 14, pageHeight - 10);
      
          const pageText = `Page ${currentPage} of ${pageCount}`;
          const textWidth = doc.getTextWidth(pageText);
          doc.text(pageText, pageWidth - textWidth - 14, pageHeight - 10);
        };
      
        doc.autoTable({
            head: [
                ['Key Name', 'Key Reference', 'Key Owner', 'Key Added Date', 'Key Status', 'Department', 'Room or Area',]
            ],
            body: filteredKeys.map((row) => [
                row.keyName,
                row.keyNumber,
                row.keyOwnerName,
                row.keyAddedDate,
                row.status,
                row.department,
                row.roomAreaName,
            ]),
            startY: 30,
            theme: 'grid',
            didDrawPage: function (data) {
                header(data);
                footer(data);
              },
              margin: { top: 35 }, // Ensures margin from top is consistent on all pages

        });
        doc.save('Key_Master.pdf');
    };

    const dropdownRef = useRef(null);
        useEffect(() => {
          const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
              setIsPanelOpen(false);
            }
          };
      
          document.addEventListener('mousedown', handleClickOutside);
          return () => document.removeEventListener('mousedown', handleClickOutside);
        }, []);


    return (
        <Container>
            <Header>
                <Heading>Key Master</Heading>
                <div style={{ display: 'flex', alignItems: 'center' }}>

                    <SearchBox>
                        <SearchIcon size={20} />
                        <SearchInput
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </SearchBox>
                    <DropdownContainerTwo ref={dropdownRef}>
                        <ExportIcon onClick={togglePanel} title="Export">
                            <FiDownload size={25} />
                        </ExportIcon>
                        {/* Show the panel with options if isPanelOpen is true */}
                        {isPanelOpen && (
                            <OptionsPanel>
                                <OptionItem onClick={() => handleExportOptionClick('excel')}>Excel</OptionItem>
                                <OptionItem onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItem>
                            </OptionsPanel>
                        )}
                    </DropdownContainerTwo>
                </div>
            </Header>
            <Card>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button className="add-location" onClick={handleAddLocationClick}>
                        Add <FiPlus size={20} />
                    </Button>
                </div>
                <div>
                    <Label>Status :<Asterisk></Asterisk></Label>
                    <DropdownSelect
                        required
                        value={currentStatusId}
                        onChange={(e) => {
                            console.log("status id:", e.target.value)
                            setCurrentStatusId(e.target.value);
                            //  fetchAllKeys(e.target.value); // Call API with updated id

                        }}
                    >
                        <option value="">Select Status</option>
                        {keyStatusList.map((status) => (
                            <option key={status.id} value={status.statusID}>
                                {status.description}
                            </option>
                        ))}
                    </DropdownSelect>
                </div>

            </Card>
            <TableContainer>
                <StyledTable>
                    <thead>
                        <tr>
                            <TableHeader colSpan={'10'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Key Master Details</span>
                                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                                        {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                                    </IconWrapper>
                                </div>
                            </TableHeader>
                        </tr>
                    </thead>
                    {isExpanded && (
                        <>
                            <thead>
                                <tr>
                                    <TableHeader onClick={() => handleSort('keyName')}>
                                        Key Name {sortColumn === 'keyName' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>
                                    <TableHeader onClick={() => handleSort('keyNumber')}>
                                        Key Reference {sortColumn === 'keyNumber' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>
                                    <TableHeader onClick={() => handleSort('keyOwnerName')}>
                                        Key Owner {sortColumn === 'keyOwnerName' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>
                                    <TableHeader onClick={() => handleSort('keyAddedDate')}>
                                        Key Added Date {sortColumn === 'keyAddedDate' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>
                                    <TableHeader onClick={() => handleSort('status')}>
                                        Key Status {sortColumn === 'status' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>
                                    <TableHeader onClick={() => handleSort('department')}>
                                        Department {sortColumn === 'department' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>
                                    <TableHeader onClick={() => handleSort('roomAreaName')}>
                                        Room or Area {sortColumn === 'roomAreaName' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>
                                    <TableHeader>Action</TableHeader>
                                </tr>
                            </thead>

                            <tbody>
                                {currentItems && currentItems.length > 0 ? (
                                    currentItems.map((row, idx) => (
                                        <TableRow key={idx}>
                                            {/* <TableCell>{row.KeyID}</TableCell> */}
                                            <TableCell>{row.keyName}</TableCell>
                                            <TableCell>{row.keyNumber}</TableCell>
                                            <TableCell>{row.keyOwnerName}</TableCell>
                                            <TableCell>{row.keyAddedDate ? (() => {
                                                const date = new Date(row.keyAddedDate);
                                                const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                const dd = String(date.getDate()).padStart(2, '0');
                                                const yyyy = date.getFullYear();
                                                const hh = String(date.getHours()).padStart(2, '0');
                                                const min = String(date.getMinutes()).padStart(2, '0');
                                                return `${mm}-${dd}-${yyyy} ${hh}:${min}`;
                                            })() : '-'}</TableCell>
                                            <TableCell>{row.status}</TableCell>
                                            <TableCell>{row.department}</TableCell>
                                            <TableCell>{row.roomAreaName}</TableCell>
                                            <TableCell>
                                                <IconWrapper onClick={() => handleEdit(row)}>
                                                    <FiEdit />
                                                </IconWrapper>
                                                {/* Uncomment if delete is needed */}
                                                {/* <IconWrapper onClick={() => handleDelete(row.id)}>
                                      <FiTrash2 />
                                    </IconWrapper> */}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>No key logs available.</TableCell>
                                    </TableRow>
                                )}
                            </tbody>
                        </>
                    )}
                </StyledTable>
                {isExpanded && (
                    <>
                        <PaginationContainer>
                            <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                                Previous
                            </PaginationButton>

                            <DropdownSelect value={currentPage} onChange={handlePageChange}>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                        Page {i + 1}
                                    </option>
                                ))}
                            </DropdownSelect>

                            <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                                Next
                            </PaginationButton>
                            <div style={{ marginLeft: '10px', color: '#000' }}>
                                Total Records: {allKeysData.length} {/* Show total records here */}
                            </div>

                        </PaginationContainer>
                    </>
                )}
                {isModalOpen && (
                    <ModalContainer>
                        <ModalHeader>
                            <ModalTitle>{isEditing ? "Update Key Entry" : "Add Key Entry"}</ModalTitle>
                            <CloseIcon size={24} onClick={handleCloseModal} />
                        </ModalHeader>

                        <InputGroup>
                            <FlexRow>
                                {/* Left Column */}
                                <InputFieldHalf>
                                    <Label>Key Name<Asterisk>*</Asterisk></Label>
                                    <Input
                                        type="text"
                                        placeholder="Enter Key Name"
                                        required
                                        value={formData.keyName}
                                        hasError={!!errors.keyName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const onlyLettersAndSpaces = value.replace(/[^a-zA-Z0-9\s]/g, ''); // ✅ allow letters and spaces only
                                            setFormData({ ...formData, keyName: onlyLettersAndSpaces });
                                        }}
                                    />
                                    {/* {errors.keyName && <span className="error">{errors.keyName}</span>} */}


                                    <Label>Key Reference (Serial Number)<Asterisk>*</Asterisk></Label>
                                    <Input
                                        type="text"
                                        placeholder="Enter Serial Number"
                                        required
                                        value={formData.keyNumber}
                                        hasError={!!errors.keyNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const alphanumericOnly = value.replace(/[^a-zA-Z0-9\s]/g, ''); // ⛔ remove special characters and spaces
                                            setFormData({ ...formData, keyNumber: alphanumericOnly });
                                        }}
                                    />
                                    {/* {errors.keyNumber && <span className="error">{errors.keyNumber}</span>} */}


                                    <Label>Key Added Date<Asterisk>*</Asterisk></Label>
                                    <Input
                                        type="datetime-local"
                                        required
                                        // style={{ padding: '6.5px 5px' }}
                                        hasError={!!errors.keyAddedDate}
                                        value={formatDateForInput(formData.keyAddedDate)}
                                        min={new Date().toISOString().slice(0, 16)}
                                        style={{ padding: '7px 0px' }}

                                        onChange={(e) =>
                                            setFormData({ ...formData, keyAddedDate: e.target.value })
                                        }
                                    />


                                    {/* {errors.keyAddedDate && <span className="error">{errors.keyAddedDate}</span>} */}


                                    <Label>Key Status<Asterisk>*</Asterisk></Label>
                                    <DropdownSelect
                                        required
                                        value={formData.statusID}
                                        hasError={!!errors.statusID}
                                        onChange={(e) =>
                                            setFormData({ ...formData, statusID: parseInt(e.target.value) })
                                        }
                                    >
                                        <option value="">Select Status</option>
                                        {statusList.map((status) => (
                                            <option key={status.id} value={status.statusID}>
                                                {status.description}
                                            </option>
                                        ))}
                                    </DropdownSelect>

                                    {/* {errors.statusID && <span className="error">{errors.statusID}</span>} */}

                                </InputFieldHalf>

                                {/* Right Column */}
                                <InputFieldHalf>
                                    <Label>Key Owner<Asterisk>*</Asterisk></Label>
                                    <DropdownSelect
                                        required
                                        value={formData.keyOwnerId}
                                        hasError={!!errors.keyOwnerId}
                                        onChange={(e) =>
                                            setFormData({ ...formData, keyOwnerId: parseInt(e.target.value) })
                                        }
                                    >
                                        <option value="">Select Employee</option>
                                        {allEmployee
                                            .filter(emp => emp.employeeName?.trim())
                                            .map((emp) => (
                                                <option key={emp.id} value={emp.id}>
                                                    {emp.employeeName}
                                                </option>
                                            ))}
                                    </DropdownSelect>
                                    {/* {errors.keyOwnerId && <span className="error">{errors.keyOwnerId}</span>} */}


                                    <Label>Department<Asterisk>*</Asterisk></Label>
                                    <DropdownSelect
                                        required
                                        value={formData.departmentID}
                                        hasError={!!errors.departmentID}
                                        style={{ padding: '7px 6px' }}

                                        onChange={(e) =>
                                            setFormData({ ...formData, departmentID: parseInt(e.target.value) })
                                        }
                                    >
                                        <option value="">Select Department</option>
                                        {departments
                                            .filter((dept) => !dept.isDeleted)
                                            .map((dept) => (
                                                <option key={dept.id} value={dept.id}>
                                                    {dept.deptDescription}
                                                </option>
                                            ))}
                                    </DropdownSelect>
                                    {/* {errors.departmentID && <span className="error">{errors.departmentID}</span>} */}


                                    <Label>Room or Area<Asterisk>*</Asterisk></Label>
                                    <Input
                                        type="text"
                                        placeholder="Enter Room or Area"
                                        required
                                        value={formData.roomAreaName}
                                        hasError={!!errors.roomAreaName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const lettersAndNumbersOnly = value.replace(/[^a-zA-Z0-9\s]/g, ''); // ⛔ removes special characters and spaces
                                            setFormData({ ...formData, roomAreaName: lettersAndNumbersOnly });
                                        }}
                                    />
                                    {/* {errors.roomAreaName && <span className="error">{errors.roomAreaName}</span>} */}

                                </InputFieldHalf>

                            </FlexRow>
                        </InputGroup>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                            <ResetButton onClick={handleReset}>Reset</ResetButton>
                            <SubmitButton onClick={() => {
                                handleSubmit();
                            }
                            }>Submit</SubmitButton>
                        </div>
                    </ModalContainer>

                )}


            </TableContainer>
            <ToastContainer />

        </Container>
    );
};

export default KeyMaster;
